import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import swal from 'sweetalert';
import { LinkedComponent } from 'valuelink';
import * as menuActions from '../../actions/MenuActions';
import LoadingImage from '../../assets/icons/load.gif';
import BSLogo from '../../assets/logos/benito-santos-mexico.svg';
import Layout from '../../components/Layout/Layout';
import Aux from '../../hoc/Aux';
import classes from './Contact.css';
import axios from 'axios';

let isContact;

const ActivityIndicator = props => <img src={LoadingImage} width="18" alt="" />;

class TailorMade extends LinkedComponent {
  constructor(props) {
    super(props);
    this.config();
  }

  state = {
    formData: {
      name: '',
      email: '',
      phone: '',
      message: ''
    },
    isBusy: false
  };

  resetForm = () => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        name: '',
        email: '',
        phone: '',
        message: ''
      }
    }));
  };

  componentDidUpdate(nextProps) {
    if (nextProps.match !== this.props.match) {
      this.resetForm();
      this.config();
    }
  }

  config = () => {
    const { path } = this.props.match;

    isContact = path === '/contacto' ? true : false;

    this.props.hideAllMenus().then(() => {
      this.props.showTopMenu();
      this.props.showLeftMenu();
    });
  };

  sendForm = async event => {
    this.setState({ isBusy: true });
    event.preventDefault();

    const { formData } = this.state;

    const subject = isContact
      ? 'Contacto - BS Web'
      : 'Solicitud de Cita - BS Web';

    try {
      const mailResponse = await axios({
        method: 'POST',
        url: 'https://bs.softwareland.mx/email',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        },
        data: {
          from: formData.email,
          name: formData.name,
          subject: subject,
          html: `<!DOCTYPE html>
          <html lang="es">
            <head>
              <meta charset="utf-8">
              <meta http-equiv="X-UA-Compatible" content="IE=edge">
              <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no"/>
              <title>Contacto - BS Web</title>
            </head>
            <body style="padding: 16px; margin: 16px;>
              <p style="font-family: TimesNewRomanPSMT, Times-Roman; line-height: 1.5;">
                ${formData.message.split('\n').join('<br/>')}
              </p>
              <hr/>
              <h4 style="font-family: TimesNewRomanPSMT, Times-Roman;">Datos de Contacto:</h4>
              <p style="font-family: TimesNewRomanPSMT, Times-Roman; line-height: 1.5;">
                ${formData.name}<br/>
                ${formData.email}<br/>
                ${formData.phone}<br/>
              </p>
            </body>
          </html>`
        }
      });

      // console.log('mailResponse', mailResponse);

      if (mailResponse.data) {
        swal('Listo!', 'Tu mensaje ha sido enviado.', 'success');
        this.setState({ isBusy: false });
        this.resetForm();
      } else {
        throw new Error('Mensaje no enviado.');
      }
    } catch (error) {
      console.log('Error', error);
      swal(
        '¡Error!',
        'Ocurrió un problema al mandar el mensaje: ' + error,
        'error'
      );
      this.setState({ isBusy: false });
    }
  };

  render() {
    const { formData } = this.linkAll('formData');
    const { isBusy } = this.state;

    const submitDisabled = !(
      formData.at('name').value &&
      formData.at('email').value &&
      formData.at('message').value
    );

    return (
      <Layout>
        <Helmet>
          <title>
            Benito Santos - {isContact ? 'Contacto' : 'Haz tu cita'}
          </title>
        </Helmet>
        <section className="container">
          <header className="row justify-content-center">
            <div className="col-sm-7 col-xl-4" style={{ textAlign: 'center' }}>
              <div className={classes.HeaderBackground} />
              <img className={classes.Logo} src={BSLogo} alt="" />
              <h2 className={classes.SectionTitle}>
                {isContact ? 'Contacto' : 'Haz tu cita'}
              </h2>
            </div>
          </header>
          <main
            className="row justify-content-center"
            style={{ marginTop: '40px' }}
          >
            <div className="col-sm-9 col-xl-6">
              <form
                className={classes.FormFrame}
                name="contact"
                onSubmit={this.sendForm}
              >
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    aria-describedby="contactName"
                    placeholder="Nombre"
                    {...formData.at('name').props}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    aria-describedby="contactEmail"
                    placeholder="E-Mail"
                    {...formData.at('email').props}
                  />
                </div>
                {!isContact && (
                  <div className="form-group">
                    <input
                      type="tel"
                      className="form-control"
                      aria-describedby="contactPhone"
                      placeholder="Teléfono"
                      {...formData.at('phone').props}
                    />
                  </div>
                )}
                <div className="form-group">
                  <textarea
                    className="form-control"
                    placeholder="Mensaje"
                    rows="4"
                    {...formData.at('message').props}
                  />
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    className={classes.SubmitButton}
                    disabled={submitDisabled || isBusy}
                    style={submitDisabled || isBusy ? { color: '#999' } : {}}
                  >
                    {isBusy ? <ActivityIndicator /> : 'Enviar'}
                  </button>
                </div>
              </form>
            </div>
          </main>
          <footer
            className="row justify-content-center"
            style={{ marginTop: '40px' }}
          >
            <div className="col-sm-8 col-xl-5">
              <div className={classes.ContactInfo}>
                <h2 className={classes.TelTitle}>Tel.</h2>
                <a href="tel:3333421950" className={classes.TelContent}>
                  (33) 3342 1950
                </a>
                {isContact ? null : (
                  <a
                    href="mailto:contacto@benitosantos.com.mx"
                    className={classes.Content}
                  >
                    contacto@benitosantos.com.mx
                  </a>
                )}
                {isContact ? (
                  <Aux>
                    <h3 className={classes.Title}>
                      Para atención a clientes y cotizaciones:
                    </h3>
                    <a
                      href="mailto:contacto@benitosantos.com.mx"
                      className={classes.Content}
                    >
                      contacto@benitosantos.com.mx
                    </a>
                    <h3 className={classes.Title}>
                      Para temas de contabilidad y recursos humanos:
                    </h3>
                    <a
                      href="mailto:administracion@benitosantos.com.mx"
                      className={classes.Content}
                    >
                      administracion@benitosantos.com.mx
                    </a>
                  </Aux>
                ) : null}
              </div>
            </div>
          </footer>
        </section>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    menu: state.menu
  };
};

const mapDispatchToStore = dispatch => {
  return bindActionCreators(
    {
      ...menuActions
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToStore)(TailorMade);



// WEBPACK FOOTER //
// ./src/containers/Contact/Contact.js